import React, { ReactNode } from 'react';
import { ColorValue, StyleProp, View, ViewStyle } from 'react-native';
import type { MissionPromotionDisplayDto } from '../../../api/api.g';
import useStyles from '../../../hooks/styles-hook';
import type { MoreInfoButtonProps } from '../MoreInfoButton';
import MissionRemunerationSummary from './MissionRemunerationSummary';
import { MissionPromotionSummary } from './MissionPromotion';
import MissionPurchaseConditions, { MissionPurchaseConditionsValue } from './MissionPurchaseConditions';
import useCustomTheme from '../../../hooks/theme-hook';

interface MissionCompensationProps {
  compensation: MissionPurchaseConditionsValue & {
    salaryAmount?: number | string;
    salaryPoints?: number;
    promotionDisplay?: MissionPromotionDisplayDto;
  };
  purchaseConditions?: MissionPurchaseConditionsValue;
  pointsOnly?: boolean;
  settled?: boolean;
  salaryLabel?: string;
  containerStyle?: StyleProp<ViewStyle>;
  textColor?: ColorValue;
  iconColor?: ColorValue;
  helpColor?: string;
  moreInfoButtonProps?: Pick<MoreInfoButtonProps, 'suspendDrawerOnOpen' | 'useLightBoxOnNative' | 'onOpen'>;
  afterReward?: ReactNode;
  children?: ReactNode;
}

const MissionCompensation = ({ compensation, purchaseConditions, pointsOnly = false, settled = false,
  salaryLabel, containerStyle, textColor, iconColor, helpColor, moreInfoButtonProps, afterReward, children }: MissionCompensationProps) => {
  const styles = useStyles(section => section.missionDetailCard);
  const theme = useCustomTheme();
  const conditions = purchaseConditions ?? compensation;
  const contentColor = textColor ?? theme.text.titleDark;
  const contentIconColor = iconColor ?? contentColor;
  const contentHelpColor = helpColor ?? contentColor.toString();
  return <View testID="mission-compensation" style={[
    styles.missionsBranchDetail.content.infoContainer.summary,
    { width: '100%', minWidth: 0, flexDirection: 'column', flexWrap: 'nowrap' },
    { borderRadius: 12, overflow: 'hidden' }, containerStyle,
  ]}>
    <MissionRemunerationSummary amount={compensation.salaryAmount} points={compensation.salaryPoints ?? 0}
      pointsOnly={pointsOnly} label={salaryLabel} textColor={contentColor} iconColor={contentIconColor} helpColor={contentHelpColor}
      totalPaymentMaxAmount={settled ? undefined : conditions.totalPaymentMaxAmount}
      moreInfoButtonProps={moreInfoButtonProps} />
    {afterReward}
    <MissionPromotionSummary display={compensation.promotionDisplay} color={contentColor} iconColor={contentIconColor} />
    <MissionPurchaseConditions conditions={conditions} settled={settled}
      showReimbursementPoints={!pointsOnly} textColor={contentColor} iconColor={contentIconColor} helpColor={contentHelpColor}
      moreInfoButtonProps={moreInfoButtonProps} />
    {children}
  </View>;
};

export default MissionCompensation;
